import curd from '../curd'

const BASE_PATH = '/icon'

export default curd(BASE_PATH)



// WEBPACK FOOTER //
// ./src/apis/modules/Icon.js